import { ToastPassThrough } from 'primeng/toast';

export const getDomainVersioningToastStyling = (): ToastPassThrough => ({
  root: {
    class: 'domain-versioning-toast-root'
  },
  message: {
    class: 'domain-versioning-toast-message'
  },
  summary: {
    class: 'domain-versioning-toast-summary'
  },
  detail: {
    class: 'domain-versioning-toast-detail'
  },
  closeButton: {
    class: 'domain-versioning-toast-close-button'
  },
  closeIcon: {
    class: 'domain-versioning-toast-close-icon'
  },
  messageIcon: {
    class: 'domain-versioning-toast-icon'
  }
});
